import { Injectable } from '@angular/core';
import {User} from '../admin/user/model/user';
import {Topic} from '../admin/topic/model/topic';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {  
    CanActivate, 
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';

export class Serializable {
    fromJSON(json) {
        for (var propName in json)
            this[propName] = json[propName];
        return this;
    }
}

export class Login extends Serializable {
        email: string;
        passwd: string;
        sessionId: string;

        constructor(){super();}
}

export class Contact {
        email: string;
        description: string;

        constructor(){}
}

@Injectable()
export class UserService implements CanActivate {
    userLoggedIn: boolean = false;
    loggedInUser = new Login();
    authUser = new Login();
    private tagsUrl = 'https://api.gleanbee.com/';
    private usersUrl = 'https://api.gleanbee.com/';

    constructor( private http: Http, private router: Router ) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean { 
        let url: string = state.url;
        return this.verifyLogin(url);
    }   

    verifyLogin(url: string): boolean {
        if (this.userLoggedIn) { return true; }
                
        this.router.navigate(['/login']);
        return false;
    }

  signUp(body: Login) {
    this.authUser.email = "";
    this.authUser.sessionId = "";
    let headers      = new Headers({ 'Content-Type': 'text/plain'});
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let bodyString = JSON.stringify(body);
    let endpoint = this.tagsUrl + 'SignUp/';
    let login = new Login();
    this.http.post(endpoint, bodyString, options)
                .map((res:Response) => res.json())
                .catch((error:any) => Observable.throw(error || alert(`${error.message} Unable to SignUp. Please, try again!`)))
                 .subscribe((json: Object) => {
                    login.fromJSON(json);
                    this.authUser.email = login.email;
                    this.authUser.sessionId = login.sessionId;
                    this.loggedInUser.email = login.email;
                    this.loggedInUser.sessionId = login.sessionId;
      })
    }

  verifyUser() : boolean {
        if (this.authUser.email) {
            this.loggedInUser = this.authUser;
            this.userLoggedIn = true;
            return true;
        }
        return false;
  }

  login(body: Login) {
    this.authUser.email = "";
    this.authUser.sessionId = "";
    let headers      = new Headers({ 'Content-Type': 'text/plain'});
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let bodyString = JSON.stringify(body);
    let endpoint = this.tagsUrl + 'Login/';
    let login = new Login();
    this.http.post(endpoint, bodyString, options)
      .map((res:Response) => res.json())
                  .catch((error:any) => Observable.throw(error || alert(`${error.message} Unable to login. Please, try again!`)))
                   .subscribe((json: Object) => {
                    login.fromJSON(json);
                    this.authUser.email = login.email;
                    this.authUser.sessionId = login.sessionId;
                    this.loggedInUser.email = login.email;
                    this.loggedInUser.sessionId = login.sessionId;
      })
  }

  relogin(body: Login) {
    this.authUser.email = "";
    this.authUser.sessionId = "";
    let headers      = new Headers({ 'Content-Type': 'text/plain'});
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let bodyString = JSON.stringify(body);
    let endpoint = this.tagsUrl + 'Relogin/';
    let login = new Login();
    this.http.post(endpoint, bodyString, options)
      .map((res:Response) => res.json())
                  .catch((error:any) => Observable.throw(error || alert(`${error.message} Unable to login. Please, try again!`)))
                   .subscribe((json: Object) => {
                    login.fromJSON(json);
                    this.authUser.email = login.email;
                    this.authUser.sessionId = login.sessionId;
                    this.loggedInUser.email = login.email;
                    this.loggedInUser.sessionId = login.sessionId;
      })
  }
  
  logoutGwt(gwt: string){
    this.authUser.email = "";
    this.authUser.sessionId = "";
    let headers      = new Headers({ 'Content-Type': 'text/plain'});
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    this.userLoggedIn = false;
    let bodyString = JSON.stringify(this.authUser);
    let endpoint = this.tagsUrl + 'LogoutGwt/?g='+gwt;
    let login = new Login();
    return this.http.post(endpoint, bodyString, options)
      .map((res:Response) => { return res})
      .catch((error:any) => Observable.throw(error || alert(`${error.message} Unable to logout. Please, try again!`)))
      .subscribe((json: Object) => {})
    this.authUser.email = "";
    this.authUser.sessionId = "";
    this.loggedInUser.email = "";
    this.loggedInUser.sessionId = "";
 }

logout(){
	this.authUser.email = "";
	this.authUser.sessionId = "";
	let headers      = new Headers({ 'Content-Type': 'text/plain'});
	let options = new RequestOptions({ headers: headers, withCredentials: true });
        this.userLoggedIn = false;
	let bodyString = JSON.stringify(this.authUser);
	let endpoint = this.tagsUrl + 'Logout/';
        return this.http.post(endpoint, bodyString, options)
		.map((res:Response) => { return res})
		.catch((error:any) => Observable.throw(error || alert(`${error.message} Unable to logout. Please, try again!`)))
		.subscribe();
   }

    reset(body: Login) {
	let headers = new Headers({ 'Content-Type': 'text/plain'});
	let options = new RequestOptions({ headers: headers, withCredentials: true  });
        let bodyString = JSON.stringify(body); 
	let endpoint = this.tagsUrl + 'Reset/';
        return this.http.post(endpoint, bodyString, options)
                .map((res:Response) => res)
                .catch((error:any) => Observable.throw(error || 'Server error'))
		.subscribe()
    }

    forgot(body: Login) {
 	let headers = new Headers({ 'Content-Type': 'text/plain'}); 
        let options = new RequestOptions({ headers: headers }); 
        let bodyString = JSON.stringify(body); 
	let endpoint = this.tagsUrl + 'Forgot/';
        return this.http.post(endpoint, bodyString, options)
                .map((res:Response) => res)
                .catch((error:any) => Observable.throw(error || 'Server error'))
		.subscribe();
    }

    invite(uemail: string, femail: string) {
 	let headers = new Headers({ 'Content-Type': 'text/plain'}); 
        let options = new RequestOptions({ headers: headers }); 
        let endpoint = this.tagsUrl + 'users/' + uemail + '/invite/' + femail;
        return this.http.post(endpoint, '', options)
                .map((res:Response) => res)
                .catch((error:any) => Observable.throw(error || 'Server error'))
		.subscribe();
    }

    accepted(uemail: string, femail: string) {
 	let headers = new Headers({ 'Content-Type': 'text/plain'}); 
        let options = new RequestOptions({ headers: headers }); 
        let endpoint = this.tagsUrl + 'users/' + uemail + '/accepted/' + femail;
        return this.http.post(endpoint, '', options)
                .map((res:Response) => res)
                .catch((error:any) => Observable.throw(error || 'Server error'))
		.subscribe();
    }

    notify(body: Topic) {
 	let headers = new Headers({ 'Content-Type': 'text/plain'}); 
        let options = new RequestOptions({ headers: headers }); 
        let bodyString = JSON.stringify(body); 
	let endpoint = this.tagsUrl + 'Notify/';
        return this.http.post(endpoint, bodyString, options)
                .map((res:Response) => res)
                .catch((error:any) => Observable.throw(error || 'Server error'))
		.subscribe();
    }

   allUsers() {
	return this.http.get(this.tagsUrl + "AllUsers/")
		.map((res:Response) => res.json())
            	.catch((error:any) => Observable.throw(error.json().error || 'Server error'));
    }

    currentUser() {
 	let headers = new Headers({ 'Content-Type': 'text/plain'}); 
	let options = new RequestOptions({ headers: headers, withCredentials: true});
	let bodyString = JSON.stringify(this.authUser);
	let user = new User("","","");
	let endpoint = this.tagsUrl + "CurrentUser/";
	this.http.post(endpoint, bodyString, options)
	.map((res:Response) => res.json())
	 .subscribe((json: Object) => {
		    user.fromJSON(json);
  this.authUser.email = user.GetEmail(); 
	this.authUser.sessionId = user.GetSessionId(); 
	})
    }

    ////// session ///////////

  sessionVerify(gwt: string)  : string{
    let headers = new Headers({ 'Content-Type': 'text/plain'}); 
    headers.append('Authorization','Bearer '+gwt);
    let options = new RequestOptions({ headers: headers, withCredentials: true});
    let endpoint = this.usersUrl + "SessionVerify/";
    let email = "";
    this.http.get(endpoint, options)
      .map((res:Response) => res.text())
      .subscribe((email: string) => {
        this.authUser.email = email; 
        this.loggedInUser.email = email;
        return email;
    });

    return email;
  }

  sessionVerifyExt()  : string{
    let headers = new Headers({ 'Content-Type': 'text/plain'}); 
    let options = new RequestOptions({ headers: headers, withCredentials: true});
    let endpoint = this.usersUrl + "SessionVerifyExt/";
    let email = "";
    this.http.get(endpoint, options)
      .map((res:Response) => res.text())
      .subscribe((email: string) => {
        this.authUser.email = email; 
        this.loggedInUser.email = email;
        return email;
    });

    return email;
  }

  sessionVerifyGwt(gwt)  : string{
    let headers = new Headers({ 'Content-Type': 'text/plain'}); 
    let options = new RequestOptions({ headers: headers, withCredentials: true});
    let endpoint = this.usersUrl + "SessionVerifyGwt/?g="+gwt;
    let email = "";
    this.http.get(endpoint, options)
      .map((res:Response) => res.text())
      .subscribe((email: string) => {
        this.authUser.email = email; 
        this.loggedInUser.email = email;
        return email;
    });

    return email;
  }
  
  
    ////// user ///////////

     getUser(h: string) : Observable<User> {
let headers      = new Headers({ 'Content-Type': 'text/plain'});
        let options       = new RequestOptions({ headers: headers, withCredentials: true  }); 
         return this.http.get(this.usersUrl + "GetUser/?h=" + h, options)
            .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  })
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     getUsers() : Observable<User[]> {

let headers      = new Headers({ 'Content-Type': 'text/plain'});
        let options       = new RequestOptions({ headers: headers, withCredentials: true  }); 


         return this.http.get(this.usersUrl, options)
            .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  })
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     searchUsers(s: string, k: string, d: string) : Observable<User[]> {
         return this.http.get(this.usersUrl + "SearchUser/?s=" + s + "&k=" + k + "&d=" + d)
            .map((res:Response) => res.json())
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     filterUsers(h: string, s: string, v: string, k: string, d: string) : Observable<User[]> {
         return this.http.get(this.usersUrl + "FilterUser/?h=" + h + "&s=" + s + "&v=" + v + "&k=" + k + "&d=" + d)
            .map((res:Response) => res.json())
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     getUserByEmail(d: string) : Observable<User> {
         return this.http.get(this.usersUrl + "UserByEmail/" + d)
            .map((res:Response) => res.json() as User)
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

    addUser (body: User): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers }); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
  return this.http.post(this.usersUrl + "users/", bodyString, options) // ...using post request
                         .map((res:Response) => res) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
}
    updateUser (body: User): Observable<Object> {
        let headers      = new Headers({ 'Content-Type': 'text/plain'}); // ... Set content type as text in order not to trigger preflight OPTIONS request
        let options       = new RequestOptions({ headers: headers}); // Create a request option
	let bodyString = JSON.stringify(body); // Stringify payload
  //alert(bodyString)
  return this.http.put(this.usersUrl + "users/" + body.ID, bodyString, options) // ...using post request
                         .map((res:Response) => {
     console.log(res);
     let headers = res.headers;
     console.log(headers);
  }) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }  

    deleteUser (id: String): Observable<Object> {
	let options       = new RequestOptions(); // Create a request option
  return this.http.delete(this.usersUrl+"users/" + id, options) // ...using delete request
                         .map((res:Response) => res) // ...and returning data
                         .catch((error:any) => Observable.throw(error || 'Server error')); //...errors if any
    }

    contact(body: Contact) {
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts